import { createUseStyles } from '../../theme/theming';

const useTeamStyles = createUseStyles((theme) => {
  return {
    teamSuperContainer: {
      background: `linear-gradient(180deg, ${theme?.colors?.background2} 50%, #FFFFFF 50%)`,
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,

      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      },
      '& h2,& h3': {
        margin: '0'
      }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    teamHeading: {
      fontSize: theme.typography.fontSize.subHead,
      textTransform: 'uppercase',
      lineHeight: '20px',
      letterSpacing: '3px',
      marginBottom: '8px',
      color: theme?.colors?.font2,
      // wordBreak: 'break-word',
      position: 'relative',
      textAlign: 'center'
    },

    teamTitle: {
      fontSize: theme.typography.fontSize.h2,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '70px',
      letterSpacing: '-3px',
      wordBreak: 'break-word',
      color: theme?.colors?.font2,
      position: 'relative',
      textAlign: 'center',
      marginBottom: '10px !important'
    },

    sliderContainer: {
      margin: '0 -20px'
    },
    contentRow: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px'
      // gridTemplateColumns: ({ slidesToShow } = {}) =>
      //   `repeat(${slidesToShow},minmax(0, 1fr))`
    },

    singleSlideContainer: {
      backgroundColor: theme?.palette?.background?.default,
      margin: '20px 0',
      borderRadius: theme?.shape?.borderRadius?.large,
      boxShadow: theme?.shadows?.primary,
      minHeight: '385px'
    },

    imageContainer: {
      minWidth: '100%',
      position: 'relative',
      height: '208px'
    },

    image: {
      width: '100%',
      height: '208px',
      top: '0',
      left: '0',
      borderRadius: '12px 12px 0px 0px',
      objectFit: 'cover'
    },

    teamDetailsContainer: {
      textAlign: 'left',
      padding: '24px'
      // overflowWrap: 'break-word'
    },

    teamDetailsHeading: {
      fontSize: theme.typography.fontSize.h6,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '24px',
      margin: '0',
      color: theme?.palette?.font?.default,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      minHeight: '2.1em'
    },

    teamDetailsSubHeading: {
      fontSize: '14px',
      lineHeight: '18px',
      color: theme?.palette?.font?.primary,
      fontWeight: '400',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical'
    },

    subHeadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0px 0px',
      gap: '6px'
    },

    starTag: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      position: 'absolute',
      marginTop: '16px',
      background: 'rgba(22, 118, 243, 1)',
      borderRadius: '0px 6px 6px 0px',
      padding: '2px 16px',
      zIndex: 2,
    },

    starTagText: {
      color: 'white',
      fontSize: '12px',
      lineHeight: '20px'
    },

    '@media (max-width: 767px)': {
      // teamSuperContainer: {
      //   padding: '60px 20px'
      // },
      teamHeading: {
        lineHeight: '20px',
        margin: 0,
        textAlign: 'center'
      },

      teamTitle: {
        marginTop: '0px',
        textAlign: 'center',
        fontSize: theme.typography.fontSize.h2,
        lineHeight: '36px',
        letterSpacing: '-1px'
      },

      sliderContainer: {
        margin: '0 -4px'
      },

      singleSlideContainer: {
        padding: '24px',
        // width: 'calc(100% - 16px)',
        margin: '12px 4px',
        minHeight: '260px'
      },

      teamDetailsContainer: {
        // textAlign: 'center'
        // margin: '15px 0 0',
        // paddingBottom: '0'
      },

      teamDetailsHeading: {
        fontSize: '16px',
        lineHeight: '24px',
        margin: '0'
      },

      teamDetailsSubHeading: {
        marginTop: '0px'
      }
    }
  };
});

export default useTeamStyles;
